import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixCartAbandonmentApiV1AbandonedCartsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_stores_abandoned-carts';

/**
 * Returns abandoned carts based on the cart ID
 * @deprecated Will be removed on 2024-03-31.
 */
export function getAbandonedCart(payload: object): RequestOptionsFactory<any> {
  function __getAbandonedCart({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.stores.v1.abandoned_cart',
      method: 'GET' as any,
      methodFqn: 'wix.cart.abandonment.api.v1.AbandonedCarts.GetAbandonedCart',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCartAbandonmentApiV1AbandonedCartsUrl({
        protoPath: '/v1/abandonedCarts/{id}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'abandonedCart.abandonTime' },
              { path: 'abandonedCart.activities.timestamp' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getAbandonedCart;
}

/**
 * Returns abandoned carts based on the requested query parameters
 * @deprecated Will be removed on 2024-03-31.
 */
export function queryAbandonedCarts(
  payload: object
): RequestOptionsFactory<any> {
  function __queryAbandonedCarts({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.stores.v1.abandoned_cart',
      method: 'POST' as any,
      methodFqn:
        'wix.cart.abandonment.api.v1.AbandonedCarts.QueryAbandonedCarts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCartAbandonmentApiV1AbandonedCartsUrl({
        protoPath: '/v1/abandonedCarts/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'abandonedCarts.abandonTime' },
              { path: 'abandonedCarts.activities.timestamp' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryAbandonedCarts;
}
